import { ReportStatus } from 'src/graphql';
import {
  defaultColorResolver,
  pendingColorResolver,
  pendingMitigationColorResolver,
  type ColorResolver,
} from './sharedStatusColorResolvers';

const speakUpDraftColorResolver: ColorResolver = () => ({
  backgroundColor: '#eab2ff',
  color: '#510073',
});

const speakUpNewColorResolver: ColorResolver = () => ({
  backgroundColor: '#abc7ff',
  color: '#002f66',
});

const speakUpReadColorResolver: ColorResolver = () => ({
  backgroundColor: '#b5d4b0',
  color: '#232429',
});

const speakUpClosedColorResolver: ColorResolver = () => ({
  backgroundColor: '#94cfc0',
  color: '#11352e',
});

const STATUS_COLOR_RESOLVERS: Record<string, ColorResolver> = {
  [ReportStatus.Draft]: speakUpDraftColorResolver,
  [ReportStatus.New]: speakUpNewColorResolver,
  [ReportStatus.Read]: speakUpReadColorResolver,
  [ReportStatus.Investigating]: pendingMitigationColorResolver,
  [ReportStatus.Closed]: speakUpClosedColorResolver,
  [ReportStatus.Lodged]: pendingColorResolver,
};

export const SpeakUpStatusColorMap = (status?: string): ColorResolver =>
  STATUS_COLOR_RESOLVERS[status?.toUpperCase() ?? ''] ?? defaultColorResolver;
